(() => {
  const selector = '#ResultsList .product-card';
  const feedbackDuration = 180;
  let scheduled = false;

  function ensureBrandCheck(button) {
    if (button.querySelector(':scope > .ps-brand-check')) return;

    const defaultIcon = button.querySelector('.svg-wrapper') || button.querySelector('svg');
    if (defaultIcon) defaultIcon.classList.add('ps-default-add-icon');

    const check = document.createElement('span');
    check.className = 'ps-brand-check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M3.7 10.5 8.1 14.4 16.5 5.7"/></svg>';
    button.append(check);
  }

  function runFeedback(button) {
    window.clearTimeout(button._psQuickAddTimer);
    button.classList.remove('ps-quick-added');
    void button.offsetWidth;
    button.classList.add('ps-quick-added');

    button._psQuickAddTimer = window.setTimeout(() => {
      button.classList.remove('ps-quick-added', 'atc-added');
    }, feedbackDuration);
  }

  function prepareButton(quickAdd, button) {
    const productTitle = quickAdd.dataset.productTitle || 'this product';
    const hasVariants = Boolean(
      quickAdd.querySelector('.quick-add__product-form-component--multi-variant')
    );
    const label = hasVariants
      ? window.psThemeText('ps.choose_product', {title: productTitle})
      : window.psThemeText('ps.add_product', {title: productTitle});

    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'inline-size', 'block-size']
      .forEach((property) => button.style.setProperty(property, '34px', 'important'));

    if (!hasVariants) ensureBrandCheck(button);

    if (button.dataset.psFastFeedback !== 'true') {
      button.dataset.psFastFeedback = 'true';
      button.addEventListener('click', () => {
        if (!hasVariants) runFeedback(button);
      });
    }
  }

  function mount(root = document) {
    root.querySelectorAll(selector).forEach((card) => {
      const content = card.querySelector('.product-card__content');
      const price = content?.querySelector(':scope > product-price');
      const quickAdd = content?.querySelector('quick-add-component');
      if (!content || !price || !quickAdd) return;

      let row = content.querySelector(':scope > .ps-card-action-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'ps-card-action-row';
        price.before(row);
        row.append(price);
      }

      if (quickAdd.parentElement !== row) row.append(quickAdd);
      quickAdd.classList.add('ps-card-add');
      quickAdd.style.setProperty('transform', 'translate(-6px, -3px)', 'important');
      quickAdd.querySelectorAll('button').forEach((button) => prepareButton(quickAdd, button));
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mount();
    });
  }

  function start() {
    mount();
    const main = document.querySelector('#MainContent');
    if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();